import { render } from "./MedicalPaidBills.vue?vue&type=template&id=5757ddac&scoped=true"
import script from "./MedicalPaidBills.vue?vue&type=script&lang=js"
export * from "./MedicalPaidBills.vue?vue&type=script&lang=js"

import "./MedicalPaidBills.vue?vue&type=style&index=0&id=5757ddac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5757ddac"]])

export default __exports__